import React from "react";
import UserPageSection from "./Content";
import { userLevels } from "../../../utils/userLevels";

const LearnMore = () => {
    return (
        <div>
            <UserPageSection>
                <div className="dashboard-cards-grid" style={{ display: "block" }}>
                    <div className="dashboard-card card-large" style={{ width: "100%" }}>
                        <div className="dashboard-card-header">
                            <span className="dashboard-card-title">User Rank Details</span>
                        </div>
                        <div className="dashboard-card-subtitle mb-4">
                            Details of all user levels based on DEOD token holdings.
                        </div>
                        <div className="dashboard-table-wrapper" style={{ marginTop: "20px", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                            <table className="dashboard-table" style={{ minWidth: "500px" }}>
                                <thead>
                                    <tr>
                                        <th>Level</th>
                                        <th>Avatars</th>
                                        <th>Rank Name</th>
                                        <th>Min DEOD Holdings</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userLevels.map((levelData) => (
                                        <tr key={levelData.level}>
                                            <td>{levelData.level}</td>
                                            <td>
                                                <img 
                                                    src={levelData.image} 
                                                    alt={levelData.name} 
                                                    style={{ width: "40px", height: "40px", objectFit: "contain" }} 
                                                />
                                            </td>
                                            <td style={{ fontWeight: "bold" }}>{levelData.name}</td>
                                            <td>{levelData.minDeodHoldings.toLocaleString() < 1000000 ? "< 100,000" : levelData.minDeodHoldings.toLocaleString()} DEOD</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </UserPageSection>
        </div>
    );
};

export default LearnMore;
